import { DECIMAL_ZERO, decimalCompare, decimalSubtract, type DecimalValue } from "../values/decimal";
import { ORDER_STATUSES, type OrderStatus } from "./order-types";
import { dateOnlyKey } from "../values/date-only";
import { ORDER_MOVEMENT_COPY } from "./order-policy-copy";

export function hasMetOrderQuantity(orderQuantity: DecimalValue, movedQuantity: DecimalValue): boolean {
  return decimalCompare(movedQuantity, 0) > 0 && decimalCompare(movedQuantity, orderQuantity) >= 0;
}

export function quantityLeft(orderQuantity: DecimalValue, movedQuantity: DecimalValue): string {
  const left = decimalSubtract(orderQuantity, movedQuantity);
  return decimalCompare(left, 0) > 0 ? left : DECIMAL_ZERO;
}

export function validateMovementDate(movementDate: Date, now: Date = new Date()): void {
  if (dateOnlyKey(movementDate) > dateOnlyKey(now)) {
    throw new Error(ORDER_MOVEMENT_COPY.futureDate);
  }
}

export function deriveMovementStatus(orderQuantity: DecimalValue, movedQuantity: DecimalValue): OrderStatus {
  return hasMetOrderQuantity(orderQuantity, movedQuantity) ? ORDER_STATUSES.fulfilled : ORDER_STATUSES.ordered;
}

export function statusAfterQuantityChange(
  currentStatus: OrderStatus,
  orderQuantity: DecimalValue,
  movedQuantity: DecimalValue,
): OrderStatus {
  if (hasMetOrderQuantity(orderQuantity, movedQuantity)) return ORDER_STATUSES.fulfilled;
  return currentStatus === ORDER_STATUSES.fulfilled ? ORDER_STATUSES.ordered : currentStatus;
}

export function canRecordMovement(status: OrderStatus): boolean {
  return status === ORDER_STATUSES.ordered || status === ORDER_STATUSES.fulfilled;
}
